import React from 'react';
import { Container, Header, Icon, Button } from 'semantic-ui-react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useTheme } from './ThemeContext';
import { supabase } from './supabaseClient';
import './NotAuthorized.css';

const NotAuthorized: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const theme = useTheme();
  const fromPath = (location.state as { from?: string } | null)?.from;
  const sanitizedPath = fromPath && fromPath !== '/' ? fromPath : null;
  const logoSrc = theme === 'dark'
    ? '/assets/Pilbara-risk-solution-logo-whitetext.svg'
    : '/assets/Pilbara-risk-solution-logo-blacktext.svg';

  return (
    <div className="not-authorized-page" role="main">
      <div className="not-authorized-glow" aria-hidden="true" />
      <Container text>
        <div className="not-authorized-card">
          <img
            src={logoSrc}
            alt="Pilbara Risk Solutions logo"
            className="not-authorized-logo"
          />
          <div className="not-authorized-icon" aria-hidden="true">
            <Icon name="lock" size="huge" />
          </div>
          <Header as="h1">Access restricted</Header>
          <p className="not-authorized-message">
            You don&apos;t have sufficient permissions to view this page.
            Please contact an administrator if you believe this is unexpected.
          </p>
          {sanitizedPath && (
            <div className="not-authorized-path" role="note">
              <span className="not-authorized-path-label">Requested page</span>
              <span className="not-authorized-path-value">{sanitizedPath}</span>
            </div>
          )}
          <div className="not-authorized-actions">
            <Button
              size="large"
              fluid
              primary
              icon="home"
              content="Return to Dashboard"
              className="not-authorized-back"
              onClick={() => {
                navigate('/', { replace: true });
              }}
            />
            <Button
              size="large"
              fluid
              primary
              icon="sign-out"
              content="Log out"
              className="not-authorized-logout"
              onClick={async () => {
                const { error } = await supabase.auth.signOut();
                if (error) {
                  console.error('[NotAuthorized] Failed to sign out', error);
                }
                navigate('/', { replace: true });
              }}
            />
          </div>
        </div>
      </Container>
    </div>
  );
};

export default NotAuthorized;
